import React, { useState, useCallback } from "react";
import { Menu, TreeDotsIcon, IconButton } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";

export const TaskOptionsMenu = ({ className, onStartEdit, onVisibilityChange, targetSize, children, ...props }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    const nextOpen = true;
    setOpen(nextOpen);
    typeof onVisibilityChange === "function" && onVisibilityChange(nextOpen);
  }, [onVisibilityChange]);
  const handleClose = useCallback(() => {
    const nextOpen = false;
    setOpen(nextOpen);
    typeof onVisibilityChange === "function" && onVisibilityChange(nextOpen);
  }, [onVisibilityChange]);

  const handleStartEdit = useCallback(() => {
    setOpen(false);
    typeof onStartEdit === "function" && onStartEdit();
  }, [onStartEdit]);

  const handleCloseMenu = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Menu
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      target={
        <IconButton
          type="button"
          variant="text gray"
          size={targetSize}
          className={classnames(className, { open })}
          active={open}
        >
          <TreeDotsIcon />
        </IconButton>
      }
      menuClassName="tw-relative tw-overflow-hidden"
      {...props}
    >
      {React.cloneElement(children, {
        onStartEdit: handleStartEdit,
        onMakeRecurring: handleCloseMenu,
        onMoveToTrash: handleCloseMenu,
        onDuplicate: handleCloseMenu,
        onEscape: handleCloseMenu,
      })}
    </Menu>
  );
};

TaskOptionsMenu.propTypes = {
  className: PropTypes.string,
  onStartEdit: PropTypes.func,
  onVisibilityChange: PropTypes.func,
  targetSize: PropTypes.string,
  children: PropTypes.node,
};

TaskOptionsMenu.defaultProps = {
  targetSize: "small",
};
